var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
import AuthedChecker from "@irati/utils/history/routing/AuthedChecker";
import APPS from "./routeConfig";
var AuthProvider = /** @class */ (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            authInit: hangPromise()
        };
        return _this;
    }
    AuthProvider.prototype.getChildContext = function () {
        return {
            authed: this.props.authed,
            unauthed: this.props.unauthed
        };
    };
    AuthProvider.prototype.componentDidMount = function () {
        var _a = this.props, authed = _a.authed, unauthed = _a.unauthed;
        this.setState({
            authInit: Promise.allSettled([authed.init(), unauthed.init()]).catch(function () { })
        });
    };
    AuthProvider.prototype.render = function () {
        return (React.createElement(Loading, { load: this.state.authInit },
            React.createElement(AuthedChecker, { apps: APPS }, this.props.children)));
    };
    AuthProvider.childContextTypes = {
        authed: PropTypes.object.isRequired,
        unauthed: PropTypes.object.isRequired
    };
    return AuthProvider;
}(PureComponent));
export default AuthProvider;
